import { breakpoints, typo } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";

import { TypographyPrimitive, type TypographyPrimitiveProps } from "../primitives/TypographyPrimitive";

const styles = stylex.create({
	root: {
		fontSize: {
			default: typo.titlePrimaryMobileFontSize,
			[breakpoints.md]: typo.titlePrimaryDesktopFontSize,
		},
		fontWeight: {
			default: typo.titlePrimaryMobileFontWeight,
			[breakpoints.md]: typo.titlePrimaryDesktopFontWeight,
		},
		lineHeight: {
			default: typo.titlePrimaryMobileLineHeight,
			[breakpoints.md]: typo.titlePrimaryDesktopLineHeight,
		},
	},
});

export const TitlePrimary = ({ render = <h1 />, ...props }: TypographyPrimitiveProps) => {
	return <TypographyPrimitive render={render} {...props} sx={[styles.root, props.sx]} />;
};
